import { DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { AddCircle } from '@material-ui/icons';
import React from 'react';

import { CalendarProfile } from 'src/models/Sessions';

import MHButton from '../../MHButton';
import { CalendarModalTestID } from './CalendarModal.models';
import { useStyles } from './CalendarModal.styles';
import { CalendarModalInfo } from './CalendarModalInfo';
import { CalendarModalProfileCard } from './CalendarModalProfileCard';

interface Props {
  profiles: CalendarProfile[];
  confirmDelete: (DeleteCalendarData) => void;
  handleCalendarUpdate: (Calendar, CalendarState) => void;
  handleSyncClick: () => void;
  missingCheckForConflicts: boolean;
  onClose: () => void;
  onContinue: () => void;
  onSendToAuthUrl: () => void;
  working: boolean;
  showContinueButton: boolean;
}

export const CalendarModalProfileView: React.FC<Props> = ({
  profiles,
  confirmDelete,
  handleCalendarUpdate,
  handleSyncClick,
  missingCheckForConflicts,
  onClose,
  onContinue,
  onSendToAuthUrl,
  working,
  showContinueButton,
}) => {
  const classes = useStyles();

  return (
    <>
      <DialogTitle
        id="form-dialog-title"
        className={classes.dialogTitle}
        disableTypography
        data-testid={CalendarModalTestID.ProfileView}
      >
        <Typography className={classes.title}>Calendar Connections</Typography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <CalendarModalInfo
          strongIntro="Add to Calendar"
          normalText="ensures that new client sessions will be added to your selected calendar."
        />
        <CalendarModalInfo
          strongIntro="Read Only"
          normalText="can be checked for conflicts, but events cannot be added to this calendar."
        />
        <CalendarModalInfo
          strongIntro="Resync"
          normalText="will resync your connection with Provider dashboard."
        />
        <CalendarModalInfo
          strongIntro="Disconnect"
          normalText="will completely remove your calendar connection."
        />
        {profiles.map((profile) => (
          <CalendarModalProfileCard
            key={profile.uuid}
            profile={profile}
            handleCalendarUpdate={handleCalendarUpdate}
            handleDeleteClick={confirmDelete}
            handleSyncClick={handleSyncClick}
            working={working}
          />
        ))}
        <div
          className={`${classes.providerCard} ${classes.addProviderCard}`}
          onClick={onSendToAuthUrl}
          data-testid={CalendarModalTestID.AddCalendarButton}
        >
          <div className={classes.providerHeading}>
            <AddCircle className={classes.addIcon} />
            <div className={classes.addText}>
              <Typography className={classes.addTitle}>Add Calendar</Typography>
              <Typography className={classes.addSubtitle}>
                We support Google, Exchange, iCloud, Outlook, and Office 365.
              </Typography>
            </div>
          </div>
        </div>
      </DialogContent>
      {showContinueButton && (
        <DialogActions>
          <MHButton
            loading={working}
            disabled={missingCheckForConflicts}
            onClick={onContinue}
            data-testid={CalendarModalTestID.ContinueDoneButton}
          >
            Continue
          </MHButton>
        </DialogActions>
      )}
    </>
  );
};
